import { connectSession } from "./session";
import { Call } from "../models/call";
import { formatAttributes } from "../../utils";
import {
  clearCurrentCallContact,
  disconnectCallContactOnRefreshError,
} from "../api/call";
import { changeAgentStateToAvailable } from "./agent";
import {
  CONTACT_STATUS_MAP,
  CONTACT_EVENT_STATE_MAP,
  CONTACT_STATE_MAP,
  LOG_PREFIX,
  STATE_CALL,
  CCP_ERROR_MESSAGE,
  API_MILO_CHANNEL_TRANSACTION,
  API_CONTACT_EVENT_LOGGING,
  CHANNEL_TYPES,
  STATE_MISSED_CALL,
} from "../constants";
import Emitter from "../../emitter";
import {
  TELEMETRY_INFO,
  TELEMETRY_ERROR,
  STATE_CONFERENCE,
  INTERNAL_CALL_RELEASE,
} from "../../constants/events";
import storeRTK from "../../store/storeRTK";
import { resetConference, setConference } from "../../actions/call";
import { setAgentGlobalMute, setAgentSelfCallHeld } from "../../actions/session";
import Player from "../../utils/audio/player";
const lp = LOG_PREFIX + "[handlers.call.ts]: ";
const defaultValue = {
  self: {},
  customer: {},
};

export const callPlayer = new Player({ type: "CALL", loop: true });

export function handleIncomingVoice(contact: any) {
  console.log(lp + "INCOMMING call contact event: ", contact);
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.INCOMING, contact);
}
export function handleConnectingVoice(contact: any) {
  console.log(lp + "CONNECTING call contact event: ", contact);
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.CONNECTING, contact);
}

export function handleMissedVoice(contact: any) {
  console.log(lp + "MISSED call contact event: ", contact, contact.isInbound());
  if (contact.isInbound()) {
    if (contact.getActiveInitialConnection() !== null) {
      //changeAgentStateToAvailable();
    } else {
      Emitter.emit(TELEMETRY_ERROR, {
        type: "notif",
        chan: TELEMETRY_INFO,
        body: {
          type: CCP_ERROR_MESSAGE,
          info: `${lp} Contact ${contact.getContactId()} was missed but not changing agent status due to initial connection(customer) disconnected.`,
        },
      });
      console.log(
        `${lp} Contact ${contact.getContactId()} was missed but not changing agent status due to initial connection(customer) disconnected.`
      );
    }
    // We will create a Event in Notification Manager to create a notification
    // Get customer information for the missed contact notification
    const customerEndpoint = contact.getActiveInitialConnection()?.getEndpoint();
    const customerAttributes = formatAttributes(contact.getAttributes());
    const queueInfo = contact.getQueue();
    const agentConnection = contact.getAgentConnection();

    console.log("Emitting STATE_MISSED_CALL event");
    try {
      // Get phone number first as we'll need it for fallback
      const phoneNumber = customerEndpoint?.phoneNumber ||
        customerAttributes?.Customer_ANI ||
        customerAttributes?.Customer_Phone ||
        'Unknown Number';
      
      // Determine customer name: use name if available, otherwise use phone number, finally fallback to 'Unknown Customer'
      let customerName = 'Unknown Customer';
      if (customerAttributes?.FIRSTNAME || customerAttributes?.LASTNAME) {
        customerName = `${customerAttributes?.FIRSTNAME || ''} ${customerAttributes?.LASTNAME || ''}`.trim();
      } else if (phoneNumber && phoneNumber !== 'Unknown Number') {
        customerName = phoneNumber;
      }

      Emitter.emit(STATE_MISSED_CALL, {
        chan: STATE_MISSED_CALL,
        body: {
          contactId: contact.contactId || contact.getContactId(),
          eventType: CONTACT_EVENT_STATE_MAP.MISSED,
          channel: CHANNEL_TYPES.VOICE,
          // Customer information
          customerName: customerName,
          phoneNumber: phoneNumber,
          // Queue information
          queueName: queueInfo?.name || 'Unknown Queue',
          queueId: queueInfo?.queueARN || null,
          // Contact details
          direction: contact.isInbound() ? 'INBOUND' : 'OUTBOUND',
          contactStartTime: agentConnection.getState().timestamp || new Date().toISOString(),
          missedAt: new Date().toISOString(),
          // Additional attributes that might be useful
          customerAttributes: customerAttributes,
          // Agent context
          agentId: agentConnection?.connectionId || null,
          // Contact duration (if available)
          contactDuration: (new Date().getTime() - new Date(agentConnection.getState().timestamp).getTime()) || 0,
        },
      });
    } catch (error) {
      console.log("Error emitting STATE_MISSED_CALL event", error);
    }
  }
  try {
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.MISSED,
      channel: CHANNEL_TYPES.VOICE,
      },
    });
  } catch (error) {
    console.log("Error emitting API_CONTACT_EVENT_LOGGING event", error);
  }
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.MISSED, contact);
}

export function handleDestroyVoice(contact: any) {

  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.RELEASED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.DESTROYED, contact);
}

export function handleAcceptedVoice(contact: any) {
  console.log(
    lp +
    "ACCEPTED call contact event: accepted by agent. Contact state is " +
    contact.getStatus().type,
    "ACCEPTED call contact event: accepted by agent. Contact state is " +
    contact.getStatus().type,
    contact
  );
  //updateCallAndSend(CONTACT_EVENT_STATE_MAP.ACCEPTED, contact);
}
export function handleConnectedVoice(contact: any) {
  console.log(
    lp +
    "CONNECTED call contact event: connected to agent. Contact state is " +
    contact.getStatus().type,
    "CONNECTED call contact event: connected to agent. Contact state is " +
    contact.getStatus().type,
    contact
  );
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.CONNECTED, contact);
  // Send message to Notification Manager to open milo URL
  Emitter.emit(API_MILO_CHANNEL_TRANSACTION, {
    chan: API_MILO_CHANNEL_TRANSACTION,
    body: {
      phoneNumber:
        contact.getActiveInitialConnection()?.getEndpoint().phoneNumber ||
        formatAttributes(contact.getAttributes())?.Customer_ANI,
      contactId: contact.contactId || contact.getContactId(),
    },
  });

  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.ESTABLISHED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
}

export function handleRefreshVoice(contact: any) {
  try {
    console.log(lp + "REFRESH call contact event: ", contact);
    updateCallAndSend(CONTACT_EVENT_STATE_MAP.REFRESH, contact);
  } catch (e) {
    handleEndedVoice(contact);
  }
}

export function handleEndedVoice(contact: any) {
  updateCallAndSend(CONTACT_EVENT_STATE_MAP.ENDED, contact);
  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.RELEASED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
  if (contact.getStatus().type === "error") {
    console.log(
      lp + "Error in call contact event: ",
      contact.getStatus().type,
      contact
    );
    Emitter.emit(TELEMETRY_ERROR, {
      type: "notif",
      chan: TELEMETRY_INFO,
      body: {
        type: CCP_ERROR_MESSAGE,
        info: lp + `Error in end contact handler.`,
        error: contact?.getStatus()?.type,
      },
    });
  }
}

const getMonitoringFlags = (
  contact: any
): { isSilent: boolean; isBarge: boolean } => {
  // Default to no monitoring - never assume true
  const defaultFlags = { isSilent: false, isBarge: false };

  try {
    // Validate contact and agent connection exist
    if (!contact || typeof contact.getAgentConnection !== "function") {
      return defaultFlags;
    }

    const agentConn = contact.getAgentConnection();
    if (!agentConn) {
      return defaultFlags;
    }

    // Primary: Use getMonitorStatus API if available (most reliable)
    if (typeof agentConn.getMonitorStatus === "function") {
      const status = agentConn.getMonitorStatus();

      // Explicitly check for null/undefined status
      if (status === null || status === undefined) {
        return defaultFlags;
      }

      // Normalize and validate status string
      const statusStr = String(status).toUpperCase().trim();
      if (!statusStr) {
        return defaultFlags;
      }

      // Explicit status matching - never assume
      const isBarge = statusStr === "BARGE" || statusStr === "BARGED";
      const isSilent = statusStr === "SILENT_MONITOR" || statusStr === "SILENT";

      return { isSilent, isBarge };
    }

    // Fallback 1: Check isSilentMonitor function
    if (typeof agentConn.isSilentMonitor === "function") {
      const silentResult = agentConn.isSilentMonitor();
      // Explicitly check for boolean true (not truthy)
      if (silentResult === true) {
        return { isSilent: true, isBarge: false };
      }
    }

    // Fallback 2: Check generic isMonitor function (treat as silent)
    if (typeof (agentConn as any).isMonitor === "function") {
      const monitorResult = (agentConn as any).isMonitor();
      // Explicitly check for boolean true (not truthy)
      if (monitorResult === true) {
        return { isSilent: true, isBarge: false };
      }
    }

    // No monitoring detected
    return defaultFlags;
  } catch (error) {
    console.warn(
      `[getMonitoringFlags] Error checking monitoring status:`,
      error
    );
    return defaultFlags;
  }
};

// Safely select the non-agent (customer) connection for a contact
function getCustomerConnectionFromContact(contact: any) {
  try {
    // Prefer initial connection if it's not an agent (inbound case)
    const initial =
      typeof contact.getActiveInitialConnection === "function" &&
      contact.getActiveInitialConnection();
    const initialType = initial && initial.getType && initial.getType();
    if (initial && String(initialType).toLowerCase() !== "agent") {
      return initial;
    }

    // Otherwise, look at third-party connections (outbound customer leg)
    if (typeof contact.getThirdPartyConnections === "function") {
      const thirdParty = contact.getThirdPartyConnections() || [];
      if (thirdParty && thirdParty.length) return thirdParty[0];
    }

    // Fallback: scan all connections for first non-agent
    if (typeof contact.getConnections === "function") {
      const all = contact.getConnections() || [];
      for (const conn of all) {
        try {
          const type = conn.getType && conn.getType();
          if (String(type).toLowerCase() !== "agent") {
            return conn;
          }
        } catch { }
      }
    }
  } catch { }
  return null;
}

export function updateCallAndSend(
  type: any,
  contact: any,
  data?: { muted: boolean }
) {
  const existingCall = Object.assign({}, connectSession.getCall());
  const updatedCall = updateCall(type, contact, data);
  if (JSON.stringify(existingCall) === JSON.stringify(updatedCall)) return;
  if (updatedCall != null) {
    connectSession.setCall(updatedCall);
  }
  Emitter.emit(STATE_CALL, updatedCall);
}

// Merge a conference snapshot with existing state and persist/emit
export function dispatchUpdatedConference(conf: any) {
  try {
    if (!conf) return;
    const isEstablished = (conf as any)?.state === "ESTABLISHED";
    const state: any = storeRTK.getState();
    const prev = state && state.conference ? state.conference : null;
    const merged = {
      ...(prev || {}),
      ...((conf as any) || {}),
      state: isEstablished ? "ESTABLISHED" : (conf as any)?.state,
      self: (conf as any)?.self
        ? { ...(conf as any).self }
        : prev && prev.self
          ? { ...prev.self }
          : null,
      allowedTransferEndpoints: Array.isArray(prev?.allowedTransferEndpoints)
        ? [...(prev!.allowedTransferEndpoints as any[])]
        : Array.isArray((conf as any)?.allowedTransferEndpoints)
          ? [...((conf as any).allowedTransferEndpoints as any[])]
          : [],
      isUnderSupervision: getSupervisionStatus(),
      beingBarged: getBargeStatus(),
    } as any;
    storeRTK.dispatch(setConference(merged));
    try {
      connectSession.setConferenceCall(merged as any);
    } catch { }
  } catch { }
}

// Maps third-party (non-agent, non-initial) connection details from a Streams contact
function mapThirdPartyConnectionsFromContact(contact: any) {
  try {
    // 1) Identify the first third-party connection efficiently
    let selectedConn: any = null;
    if (typeof contact.getThirdPartyConnections === "function") {
      const list = contact.getThirdPartyConnections() || [];
      selectedConn = list && list.length ? list[0] : null;
    } else if (typeof contact.getConnections === "function") {
      const all = contact.getConnections() || [];
      const initial = contact.getActiveInitialConnection && contact.getActiveInitialConnection();
      for (const conn of all) {
        try {
          const type = conn.getType && conn.getType();
          if (
            type &&
            String(type).toLowerCase() !== "agent" &&
            conn !== initial
          ) {
            selectedConn = conn;
            break;
          }
        } catch { }
      }
    }

    if (!selectedConn) return null;

    // 2) Snapshot state once
    let currentCall: any = null;
    let currentConference: any = null;
    try {
      const reduxState: any = storeRTK.getState();
      currentCall = reduxState.call;
      currentConference = reduxState.conference;
    } catch { }

    // 3) Derive connection details
    const endpoint = selectedConn.getEndpoint && selectedConn.getEndpoint();
    const status = selectedConn.getStatus && selectedConn.getStatus();
    const isConnected = selectedConn.isConnected && selectedConn.isConnected();
    const rawState = status?.type ? String(status.type).toUpperCase() : undefined;

    let normalizedState;
    if (rawState === "DISCONNECTED" || rawState === "FAILED" || rawState === "REJECTED") {
      normalizedState = rawState;
    } else if (isConnected) {
      normalizedState = "ESTABLISHED";
    } else if (rawState === "CONNECTING" || rawState === "DIALING") {
      normalizedState = "DIALING";
    } else {
      normalizedState = rawState || "DISCONNECTED";
    }

    const connId =
      selectedConn.connectionId ||
      (selectedConn.getConnectionId && selectedConn.getConnectionId());

    // 4) Build agent self from existing state (no extra Streams reads)
    const sourceSelf = (currentConference && currentConference.self) || (currentCall && currentCall.self) || null;
    const agentSelf = sourceSelf
      ? {
        id: connId,
        quickConnectName: selectedConn.getQuickConnectName(),
        state:
          sourceSelf.state === "RELEASED" || sourceSelf.state === "ENDED"
            ? sourceSelf.state
            : normalizedState,
        direction: "OUTBOUND" as "INBOUND" | "OUTBOUND",
        endTime: sourceSelf.endTime || Date.now(),
        muted: selectedConn.isMute(),
        connectedTime: Date.now() || 0,
        held: selectedConn.isOnHold(),
        missed: false,
        type: "AGENT",
        displayName: "",
        phoneNumber: "",
      }
      : null;

    // 5) Customer (participant) view
    const customer = {
      id: connId,
      state: normalizedState,
      displayName: endpoint?.phoneNumber || "",
      phoneNumber: endpoint?.phoneNumber || "",
      direction: "OUTBOUND" as "INBOUND" | "OUTBOUND",
      connectedTime: isConnected ? Date.now() : 0,
      attributes: formatAttributes(contact.getAttributes?.() || ({} as any)),
    };

    return {
      id: contact.contactId || contact.getContactId(),
      customer,
      self: agentSelf,
      queue: undefined,
      allowedTransferEndpoints:
        (currentConference && currentConference.allowedTransferEndpoints) ||
        (currentCall && currentCall.allowedTransferEndpoints) ||
        [],
      dialCallInProgress:
        (currentConference && (currentConference as any).dialCallInProgress) ||
        (currentCall && currentCall.dialCallInProgress) ||
        false,
    };
  } catch (e) {
    return null;
  }
}

// Centralized logic to sync conference slice and agent flags during REFRESH
function syncConferenceAndAgentStateOnRefresh(
  contact: any,
): void {
  try {
    const conf = mapThirdPartyConnectionsFromContact(contact);
    if (conf && (conf as any)?.self?.state == "DISCONNECTED") {
      Emitter.emit(INTERNAL_CALL_RELEASE, conf);
      storeRTK.dispatch(resetConference());
    }
    if (conf && (conf as any)?.customer?.state !== "DISCONNECTED") {
      dispatchUpdatedConference(conf);
    }
    // Check if agent connection is held
    const agentConnection = contact.getAgentConnection();
    console.log("agentConnection", agentConnection);
    console.log("agentConnection.isOnHold()", agentConnection.isOnHold());
    if (agentConnection && agentConnection.isOnHold()) {
      storeRTK.dispatch(setAgentSelfCallHeld({ isAgentSelfCallHeld: true }));
    } else {
      storeRTK.dispatch(setAgentSelfCallHeld({ isAgentSelfCallHeld: false }));
    }
    // Check if agent connection is muted
    if (agentConnection && agentConnection.isMute()) {
      storeRTK.dispatch(setAgentGlobalMute({ isAgentGloballyMuted: true }));
    } else {
      storeRTK.dispatch(setAgentGlobalMute({ isAgentGloballyMuted: false }));
    }
  } catch { }
}

function updateCall(
  contactEventType: string,
  contact: any,
  data?: { muted: boolean }
): Call | null {
  try {
    let call = connectSession.getCall() || { ...defaultValue }; // Create a new object if call is null
    let updatedCall;
    switch (contactEventType) {
      case CONTACT_EVENT_STATE_MAP.INITIAL:
        // Similar logic, but ensure we create a new object
        try {
          const cstate = contact.getState();
          const ctype: string = cstate?.type;
          let cstate_type: string = (CONTACT_EVENT_STATE_MAP as any)[
            ctype.toUpperCase()
          ];
          if (
            cstate_type === CONTACT_EVENT_STATE_MAP.ENDED ||
            ctype === "error"
          ) {
            console.log(
              "Initial call but either ended or with error state, returning call",
              call
            );
            return call;
          }
        } catch (error) {
          console.log("Error during state check", error);
        }
        const flagsInit = getMonitoringFlags(contact);
        // Determine customer (non-agent) connection without overriding existing ID
        const customerConn = getCustomerConnectionFromContact(contact);
        const customerEndpoint =
          customerConn && customerConn.getEndpoint && customerConn.getEndpoint();
        const computedCustomerId =
          (customerConn &&
            (customerConn.connectionId ||
              (customerConn.getConnectionId && customerConn.getConnectionId()))) ||
          undefined;
        updatedCall = {
          ...call,
          id: contact.contactId || contact.getContactId(),
          isSilentMonitor: flagsInit.isSilent,
          isBarge: flagsInit.isBarge,
          beingBarged: getBargeStatus(),
          self: {
            ...call.self,
            id: getCustomerConnectionFromContact(contact)?.connectionId || contact.getAgentConnection().connectionId,
            state: contact.isInbound()
              ? CONTACT_STATE_MAP.INCOMING
              : CONTACT_STATE_MAP.DIALING,
            direction: contact.isInbound() ? "INBOUND" : "OUTBOUND",
            attributes: {},
            notes: "",
            endTime: "",
            muted: getCustomerConnectionFromContact(contact)?.isMute() || false,
            connectedTime: undefined,
            isMonitoringCall: flagsInit.isSilent || flagsInit.isBarge,
            isBarge: flagsInit.isBarge,
          },
          customer: {
            ...call.customer,
            // Do not override existing customer id (important for conference scenarios)
            id: call.customer?.id || computedCustomerId,
            state: CONTACT_STATE_MAP.CONNECTED,
            attributes: formatAttributes(contact.getAttributes()),
            displayName:
              customerEndpoint?.phoneNumber || call.customer?.displayName,
            phoneNumber:
              customerEndpoint?.phoneNumber || call.customer?.phoneNumber,
          },
        };
        const conf = mapThirdPartyConnectionsFromContact(contact);
        if (conf) dispatchUpdatedConference(conf);
        return updatedCall;

      case CONTACT_EVENT_STATE_MAP.CONNECTING:
      case CONTACT_EVENT_STATE_MAP.INCOMING:
        return {
          ...call,
          self: {
            ...call.self,
            state: contact.isInbound()
              ? CONTACT_STATUS_MAP.INCOMING
              : CONTACT_STATUS_MAP.CONNECTING,
          },
        };

      case CONTACT_EVENT_STATE_MAP.CONNECTED:
        const flagsConn = getMonitoringFlags(contact);
        updatedCall = {
          ...call,
          isSilentMonitor: flagsConn.isSilent,
          isBarge: flagsConn.isBarge,
          beingBarged: getBargeStatus(),
          self: {
            ...call.self,
            id: getCustomerConnectionFromContact(contact)?.connectionId || contact.getAgentConnection().connectionId,
            state: CONTACT_STATE_MAP.CONNECTED,
            held: call.self?.held || contact.getAgentConnection()?.isOnHold(),
            muted: getCustomerConnectionFromContact(contact)?.isMute() || false,
            connectedTime: call.self.connectedTime || new Date().getTime(),
            isMonitoringCall: flagsConn.isSilent || flagsConn.isBarge,
            isBarge: flagsConn.isBarge,
          },
        };
        try {
          const conf = mapThirdPartyConnectionsFromContact(contact);
          dispatchUpdatedConference(conf);
        } catch { }
        return updatedCall;

      case CONTACT_EVENT_STATE_MAP.MISSED:
        updatedCall = {
          ...call,
          self: {
            ...call.self,
            missed: true,
          },
        };
        clearCurrentCallContact();
        return updatedCall;

      case CONTACT_EVENT_STATE_MAP.ENDED:
      case CONTACT_EVENT_STATE_MAP.DESTROYED:
        return {
          ...call,
          self: {
            ...call.self,
            state: CONTACT_STATE_MAP.ENDED,
            connectedTime: call.self.connectedTime || new Date().getTime(),
            endTime: call.self.endTime || new Date().getTime(),
          },
        };

      case CONTACT_EVENT_STATE_MAP.REFRESH:
        const state = contact.getState();
        const contactId = contact.contactId || contact.getContactId();
        const type: string = state.type;
        if (type === "error") {
          if ((call && call.id === contactId) || !call?.id) {
            disconnectCallContactOnRefreshError({ conversationId: contactId });
          }
          const flagsErr = getMonitoringFlags(contact);
          return {
            ...call,
            isSilentMonitor: flagsErr.isSilent,
            isBarge: flagsErr.isBarge,
            beingBarged: getBargeStatus(),
          };
        }
        // Similar logic for handling refresh
        let selfState: string = (CONTACT_STATE_MAP as any)[type.toUpperCase()];
        if (
          call.id === contactId &&
          selfState !== CONTACT_EVENT_STATE_MAP.ENDED
        ) {
          const flagsRef = getMonitoringFlags(contact);
          // keep conference slice in sync on refresh
          syncConferenceAndAgentStateOnRefresh(contact);

          // If we're in a conference and we have a tracked customer id, but that id
          // is no longer present in the active connections, treat the call as ended.
          const store = storeRTK.getState();
          if ((store as any)?.conference?.id && call?.customer?.id) {
            const getId = (c: any) =>
              c?.connectionId || (c?.getConnectionId && c.getConnectionId());
            const activeConnections =
              typeof contact.getActiveConnections === "function"
                ? contact.getActiveConnections() || []
                : [];
            const exists = activeConnections.some(
              (conn: any) => getId(conn) === call.customer.id
            );
            if (!exists) {
              return {
                ...call,
                self: {
                  ...call.self,
                  state: CONTACT_STATE_MAP.ENDED,
                  connectedTime: call.self.connectedTime || new Date().getTime(),
                  endTime: call.self.endTime || new Date().getTime(),
                },
              } as Call;
            }
          }

          return {
            ...call,
            isSilentMonitor: flagsRef.isSilent,
            isBarge: flagsRef.isBarge,
            beingBarged: getBargeStatus(),
            self: {
              ...call.self,
              state: selfState,
              held: contact.getActiveInitialConnection()?.isOnHold(),
              muted: getCustomerConnectionFromContact(contact)?.isMute() || false,
              isMonitoringCall: flagsRef.isSilent || flagsRef.isBarge,
              isBarge: flagsRef.isBarge,
            },
            customer: {
              ...call.customer,
              attributes: formatAttributes(contact.getAttributes()),
            },
          };
        } else {
          syncConferenceAndAgentStateOnRefresh(contact)
        }

        return call;

      default:
        return call;
    }
  } catch (err) {
    console.log(lp + "Error in updating call: " + err);
    return null;
  }
}

// Note: updateConferenceOnRefresh helper removed; inline update logic is used where needed

export function updateConferenceAndSend(
  type: any,
  contact: any,
  data?: { muted: boolean }
) {
  const existingConference = Object.assign(
    {},
    connectSession.getConferenceCall() || {}
  );
  const updatedConference = updateConferenceCall(type, contact, data);
  if (JSON.stringify(existingConference) === JSON.stringify(updatedConference))
    return;
  if (updatedConference != null) {
    connectSession.setConferenceCall(updatedConference);
  }
  try {
    const {
      allowedTransferEndpoints,
      dialCallInProgress,
      queue,
      state: _state,
      ...sanitized
    } = (updatedConference || {}) as any;
    Emitter.emit(STATE_CONFERENCE, sanitized);
  } catch {
    Emitter.emit(STATE_CONFERENCE, updatedConference);
  }
}

// Helper function to get supervision status
const getSupervisionStatus = (): boolean => {
  try {
    const voiceContacts = connectSession.agent.getContacts(
      connect.ContactType.VOICE
    );
    if (voiceContacts && voiceContacts.length > 0) {
      const firstVoiceContact = voiceContacts[0];
      if (typeof firstVoiceContact.isUnderSupervision === "function") {
        return firstVoiceContact.isUnderSupervision();
      }
    }
    return false;
  } catch (error) {
    console.log("Error getting supervision status:", error);
    return false;
  }
};

// Helper function to get barge status - checks all active connections
const getBargeStatus = (): boolean => {
  try {
    const voiceContacts = connectSession.agent.getContacts(
      connect.ContactType.VOICE
    );
    if (voiceContacts && voiceContacts.length > 0) {
      const firstVoiceContact = voiceContacts[0];
      if (typeof firstVoiceContact.getActiveConnections === "function") {
        const activeConnections = firstVoiceContact.getActiveConnections();
        if (activeConnections && Array.isArray(activeConnections)) {
          // Check if any connection is being barged
          for (const connection of activeConnections) {
            if (
              typeof connection.isBarge === "function" &&
              connection.isBarge()
            ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  } catch (error) {
    console.log("Error getting barge status:", error);
    return false;
  }
};

function updateConferenceCall(
  contactEventType: string,
  contact: any,
  data?: { muted: boolean }
): any {
  try {
    let conference = connectSession.getConferenceCall() || { ...defaultValue }; // Create a new object if call is null
    let updatedConference;
    switch (contactEventType) {
      case CONTACT_EVENT_STATE_MAP.INITIAL:
        // Similar logic, but ensure we create a new object
        try {
          const cstate = contact.getState();
          const ctype: string = cstate?.type;
          let cstate_type: string = (CONTACT_EVENT_STATE_MAP as any)[
            ctype.toUpperCase()
          ];
          if (
            cstate_type === CONTACT_EVENT_STATE_MAP.ENDED ||
            ctype === "error"
          ) {
            console.log(
              "Initial call but either ended or with error state, returning call",
              conference
            );
            return conference;
          }
        } catch (error) {
          console.log("Error during state check", error);
        }
        updatedConference = {
          ...conference,
          id: contact.contactId || contact.getContactId(),
          isSilentMonitor: getMonitoringFlags(contact),
          self: {
            ...conference.self,
            id: getCustomerConnectionFromContact(contact)?.connectionId || contact.getAgentConnection().connectionId,
            state: contact.isInbound()
              ? CONTACT_STATE_MAP.INCOMING
              : CONTACT_STATE_MAP.DIALING,
            direction: "OUTBOUND",
            attributes: {},
            held: conference.self?.held || false,
            notes: "",
            endTime: conference.self?.endTime || new Date().getTime(),
            muted: conference.self?.muted,
            connectedTime: undefined,
            isMonitoringCall: getMonitoringFlags(contact),
          },
          customer: {
            ...conference.customer,
            state: CONTACT_STATE_MAP.CONNECTED,
            attributes: formatAttributes(contact.getAttributes()),
            // keep conference.customer phone aligned to non-agent connection if available
            displayName:
              (getCustomerConnectionFromContact(contact)?.getEndpoint?.() || {})
                .phoneNumber || conference.customer?.displayName,
            phoneNumber:
              (getCustomerConnectionFromContact(contact)?.getEndpoint?.() || {})
                .phoneNumber || conference.customer?.phoneNumber,
          },
        };
        const conf = mapThirdPartyConnectionsFromContact(contact);
        if (conf) {
          storeRTK.dispatch(
            setConference({
              ...conf,
              isUnderSupervision: getSupervisionStatus(),
              beingBarged: getBargeStatus(),
            })
          );
        }
        return updatedConference;

      case CONTACT_EVENT_STATE_MAP.CONNECTING:
      case CONTACT_EVENT_STATE_MAP.INCOMING:
        return {
          ...conference,
          self: {
            ...(conference.self || {}),
            id:
              (conference.self && conference.self.id) ||
              (getCustomerConnectionFromContact(contact)?.connectionId) ||
              (contact.getAgentConnection &&
                contact.getAgentConnection().connectionId),
            direction:
              (conference.self && conference.self.direction) || "OUTBOUND",
            state: contact.isInbound()
              ? CONTACT_STATUS_MAP.INCOMING
              : CONTACT_STATUS_MAP.CONNECTING,
          },
        };

      case CONTACT_EVENT_STATE_MAP.CONNECTED:
        updatedConference = {
          ...conference,
          isSilentMonitor: getMonitoringFlags(contact),
          self: {
            ...conference.self,
            state: CONTACT_STATE_MAP.CONNECTED,
            held: conference.self?.held || false,
            muted: conference?.self?.mute || false,
            connectedTime:
              conference.self.connectedTime || new Date().getTime(),
          },
        };
        try {
          const conf = mapThirdPartyConnectionsFromContact(contact);
          if (conf) {
            const isEstablished = (conf as any)?.state === "ESTABLISHED";
            storeRTK.dispatch(
              setConference({
                ...(conf as any),
                state: isEstablished ? "ESTABLISHED" : (conf as any)?.state,
                isUnderSupervision: getSupervisionStatus(),
                beingBarged: getBargeStatus(),
              })
            );
          }
        } catch { }
        return updatedConference;

      case CONTACT_EVENT_STATE_MAP.MISSED:
        updatedConference = {
          ...conference,
          self: {
            ...conference.self,
            missed: true,
          },
        };
        clearCurrentCallContact();
        return updatedConference;

      case CONTACT_EVENT_STATE_MAP.ENDED:
      case CONTACT_EVENT_STATE_MAP.DESTROYED:
        return {
          ...conference,
          self: {
            ...conference.self,
            state: CONTACT_STATE_MAP.ENDED,
            connectedTime:
              conference.self.connectedTime || new Date().getTime(),
              endTime: conference.self.endTime || new Date().getTime(),
          },
        };

      case CONTACT_EVENT_STATE_MAP.REFRESH:
        const state = contact.getState();
        const contactId = contact.contactId || contact.getContactId();
        const type: string = state.type;
        if (type === "error") {
          if ((conference && conference.id === contactId) || !conference?.id) {
            console.log(lp + "Disconnecting call contact on refresh error", contactId);
            disconnectCallContactOnRefreshError({ conversationId: contactId });
          }
          return {
            ...conference,
            isSilentMonitor: getMonitoringFlags(contact),
          };
        }
        // Similar logic for handling refresh
        let selfState: string = (CONTACT_STATE_MAP as any)[type.toUpperCase()];
        if (
          conference.id === contactId &&
          selfState !== CONTACT_EVENT_STATE_MAP.ENDED
        ) {
          // keep conference slice in sync on refresh
          try {
            const confOnRefresh = mapThirdPartyConnectionsFromContact(contact);
            if (
              confOnRefresh &&
              (confOnRefresh as any)?.customer?.state !== "DISCONNECTED"
            ) {
              const isEstablished = (confOnRefresh as any)?.state === "ESTABLISHED";
              storeRTK.dispatch(
                setConference({
                  ...(confOnRefresh as any),
                  state: isEstablished ? "ESTABLISHED" : (confOnRefresh as any)?.state,
                  customer: {
                    ...((confOnRefresh as any)?.customer),
                    held: (confOnRefresh as any)?.customer?.held,
                  },
                  isUnderSupervision: getSupervisionStatus(),
                  beingBarged: getBargeStatus(),
                })
              );
            }
          } catch { }
          return {
            ...conference,
            self: {
              ...conference.self,
              state: selfState,
              held: conference?.self?.held || false,
              muted: conference?.self?.muted,
            },
            customer: {
              ...conference.customer,
              attributes: formatAttributes(contact.getAttributes()),
            },
          };
        }
        try {
          const conf = mapThirdPartyConnectionsFromContact(contact);
          if (conf) {
            const isEstablished = (conf as any)?.state === "ESTABLISHED";
            storeRTK.dispatch(
              setConference({
                ...(conf as any),
                state: isEstablished ? "ESTABLISHED" : (conf as any)?.state,
                isUnderSupervision: getSupervisionStatus(),
                beingBarged: getBargeStatus(),
              })
            );
          }
        } catch { }
        return conference;

      case CONTACT_EVENT_STATE_MAP.MUTETOGGLE:
        return {
          ...conference,
          self: {
            ...conference.self,
            muted: data?.muted,
          },
        };

      default:
        return conference;
    }
  } catch (err) {
    console.log(lp + "Error in updating conference: " + err);
    return null;
  }
}
